/*
 * 文件管理接口
 * */
import services from "../config/axios";
import base from "./base"; // 导入接口域名列表

// 定义参数类型
type paramsType<T> = {
  [key: string]: T;
};

const formsAPI = {

  //修改别名
  updateUserAlias(file: File | FormData) {
    return services.post(`${base.lk}/Question/updateUserAlias`, file);
  },
  //设置帖子 【禁止回复，精华，置顶，可见】
  updateArticleState(file: File | FormData) {
    return services.post(`${base.lk}/Question/updateArticleState`, file);
  },
  //设置板块
  updateArticleSection(file: File | FormData) {
    return services.post(`${base.lk}/Question/updateArticleSection`, file);
  },
  //设置分类
  updateArticleCate(file: File | FormData) {
    return services.post(`${base.lk}/Question/UpdateArticleCate`, file);
  },
  //根据默认头像更新用户头像
  updateUserPortraitByDF(file: File | FormData) {
    return services.post(`${base.lk}/Question/UpdateUserPortraitByDF`, file);
  },
  //获取默认头像
  getDefaultPortrait(file: File | FormData) {
    return services.post(`${base.lk}/Question/GetDefaultPortrait`, file);
  },
  //取消点赞或收藏
  getArticleByReplyer(file: File | FormData) {
    return services.post(`${base.lk}/Question/GetArticleByReplyer`, file);
  },
  //取消点赞或收藏
  delThumbsUpCollect(file: File | FormData) {
    return services.post(`${base.lk}/Question/DelThumbsUpCollect`, file);
  },
  //查看帖子
  getArticleByUser(file: File | FormData) {
    return services.post(`${base.lk}/Question/GetArticleByUser`, file);
  },
  //查询精华帖
  getEliteArticle(file: File | FormData) {
    return services.post(`${base.lk}/Question/GetEliteArticle`, file);
  },
  //查询论坛类型
  getForumType(file: File | FormData) {
    return services.post(`${base.lk}/Question/GetForumType`, file);
  },
  //查询论坛分类
  getForumGategory(file: File | FormData) {
    return services.post(`${base.lk}/Question/GetForumGategory`, file);
  },
  //查询论坛标签
  getForumLabel(file: File | FormData) {
    return services.post(`${base.lk}/Question/GetForumLabel`, file);
  },
  //查询论坛帖子
  getForumArticle(file: File | FormData) {
    return services.post(`${base.lk}/Question/GetForumArticle`, file);
  },
  //设置帖子为精华
  setEliteArticle(file: File | FormData) {
    return services.post(`${base.lk}/Question/SetEliteArticle`, file);
  },
  //查询帖子回复
  getArticleReply(file: File | FormData) {
    return services.post(`${base.lk}/Question/GetArticleReply`, file);
  },
  //新增帖子回复
  addArticleReply(file: File | FormData) {
    return services.post(`${base.lk}/Question/AddArticleReply`, file);
  },
  //新增帖子回复带附件
  addArticleReplyWithFile(file: File | FormData) {
    return services.post(`${base.lk}/Question/AddArticleReplyWithFile`, file);
  },
  //删除帖子回复
  delArticleReply(file: File | FormData) {
    return services.post(`${base.lk}/Question/DelArticleReply`, file);
  },
  //查询用户积分
  getUserCredits(file: File | FormData) {
    return services.post(`${base.lk}/Question/GetUserCredits`, file);
  },
  //新增帖子
  addForumArticle(file: File | FormData) {
    return services.post(`${base.lk}/Question/AddForumArticle`, file);
  },
  //新增帖子带附件
  addForumArticleWithFile(file: File | FormData) {
    return services.post(`${base.lk}/Question/AddForumArticleWithFile`, file);
  },
  //删除贴子
  delForumArticle(file: File | FormData) {
    return services.post(`${base.lk}/Question/DelForumArticle`, file);
  },
  //更新帖子
  updateForumArticle(file: File | FormData) {
    return services.post(`${base.lk}/Question/UpdateForumArticle`, file);
  },
  //更新帖子带附件
  updateForumArticleWithFile(file: File | FormData) {
    return services.post(`${base.lk}/Question/UpdateForumArticleWithFile`, file);
  },
  //帖子点赞或收藏
  addThumbsUpCollect(file: File | FormData) {
    return services.post(`${base.lk}/Question/AddThumbsUpCollect`, file);
  },
  //查询用户收藏帖子清单
  getArticleCollect(file: File | FormData) {
    return services.post(`${base.lk}/Question/GetArticleCollect`, file);
  },
  //查询用户消息
  getArticleMessage(file: File | FormData) {
    return services.post(`${base.lk}/Question/GetArticleMessage`, file);
  },
  //加积分
  addUserCredit(file: File | FormData) {
    return services.post(`${base.lk}/Question/AddUserCredit`, file);
  },
  //加积分
  delUserCredit(file: File | FormData) {
    return services.post(`${base.lk}/Question/DelUserCredit`, file);
  },
  //查询用户积分等信息
  getUserInfo(file: File | FormData) {
    return services.post(`${base.lk}/Question/GetUserInfo`, file);
  },
  //查询论坛版块
  getForumSection(file: File | FormData) {
    return services.post(`${base.lk}/Question/GetForumSection`, file);
  },
  // // 回复帖子接口
  // addArticleReplyWithFile(file: File | FormData) {
  //   return services.post(`${base.lk}/Question/AddArticleReplyWithFile`, file);
  // },
  // // 发布帖子接口
  // addForumArticleWithFile(file: File | FormData) {
  //   return services.post(`${base.lk}/Question/AddForumArticleWithFile`, file);
  // },
  // 文件上传接口
  upload(file: File | FormData) {
    return services.post(`${base.lk}/Upload/PostFile`, file);
  },
  // 文件上传接口
  downloadShareFile(params:  FormData) {
    return services.post(`${base.lk}/Upload/DownloadShareFile`, params);
  },
  // 文件列表
  getUserFileList<T>(params: paramsType<T>) {
    return services.get(`${base.lk}/fileManagement/getUserFileList`, {
      params: params
    });
  },
  // 添加文件
  getAddFileInfo<T>(params: paramsType<T>) {
    return services.post(`${base.lk}/fileManagement/addFileInfo`, params);
  }
};

export default formsAPI;
